<template>
  <div class="login-wrap">
    <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
      class="demo-ruleForm login-container">
      <!--  -->
      <h3 class="title">{{ loginTitle }}</h3>
      <div class="segmented" role="tablist" aria-label="登录身份切换">
        <div class="segmented-track">
          <div class="segmented-thumb" :style="{ transform: loginMode==='admin' ? 'translateX(0%)' : 'translateX(100%)' }"></div>
        </div>
        <button type="button" :class="{ active: loginMode==='admin' }" @click="switchMode('admin')" aria-selected="loginMode==='admin'">管理员</button>
        <button type="button" :class="{ active: loginMode==='salesperson' }" @click="switchMode('salesperson')" aria-selected="loginMode==='salesperson'">业务员</button>
      </div>
      <el-form-item prop="name">
        <el-input v-model="ruleForm.name" autocomplete="off" :placeholder="accountPlaceholder" clearable prefix-icon="el-icon-user"></el-input>
      </el-form-item>
      <el-form-item prop="pswd">
        <el-input v-model="ruleForm.pswd" autocomplete="off" :placeholder="passwordPlaceholder" show-password prefix-icon="el-icon-lock"></el-input>
      </el-form-item>

      <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button class="ios-primary-btn" type="primary" style="width:100%; border-radius: 14px;" @click="submitForm('ruleForm')" :loading="logining">{{ loginButtonText }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script type="text/ecmascript-6">
import { login, getInfo, salespersonLogin, getSalespersonInfo } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'
import md5 from 'js-md5'
export default {
  name: 'login',
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      loginMode: 'admin',
      ruleForm: {
        //username和password默认为空
        name: '',
        pswd: '',

      },
      //rules前端验证
      rules: {
        name: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        pswd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      }
    }
  },
  computed: {
    loginTitle() {
      return this.loginMode === 'salesperson' ? '业务员登录' : '管理员登录'
    },
    accountPlaceholder() {
      return this.loginMode === 'salesperson' ? '业务员手机号' : '账号'
    },
    passwordPlaceholder() {
      return '密码'
    },
    loginButtonText() {
      return '登录'
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取存在本地的用户名密码
    this.getuserpwd()
    this.loginMode = getCookie('loginMode') || 'admin'
  },
  // 里面的函数只有调用才会执行
  methods: {
    switchMode(mode) {
      this.loginMode = mode
      setCookie('loginMode', mode)
      // 切换身份时清空密码，避免误操作
      this.ruleForm.pswd = ''
    },
    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.name = getCookie('user')
        this.ruleForm.pswd = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true
          // 测试通道，不为空直接登录
          let loginApi = this.loginMode === 'salesperson' ? salespersonLogin : login
          let params = this.loginMode === 'salesperson' ? { phone: this.ruleForm.name, password: this.ruleForm.pswd } : this.ruleForm
          loginApi(params).then(res => {
            if (res.code === 200) {
              if (this.rememberpwd) {
                //保存帐号到cookie，有效期7天
                setCookie('user', this.ruleForm.name, 7)
                //保存密码到cookie，有效期7天
                setCookie('pwd', this.ruleForm.pswd, 7)
              } else {
                delCookie('user')
                delCookie('pwd')
              }
              // 缓存token
              localStorage.setItem('logintoken', res.data)
              let getInfoApi = this.loginMode === 'salesperson' ? getSalespersonInfo : getInfo
              getInfoApi().then(result => {
                this.$store.commit('login', JSON.stringify(result.data))
                localStorage.setItem('userdata', JSON.stringify(result.data))
                this.$router.replace('/salesperson')
              })
             
            } else {
              this.$message.error(res.message)
              this.logining = false
              return false
            }
          })
        } else {
          // 获取图形验证码
          this.getcode()
          this.$message.error('请输入用户名密码！')
          this.logining = false
          return false
        }
      })
    },
  }
}
</script>

<style lang="less" >
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  padding-top: 8vh;
  background: radial-gradient(ellipse at top left, rgba(201, 160, 220, 0.5) 0%, transparent 50%), radial-gradient(ellipse at top right, rgba(138, 180, 248, 0.5) 0%, transparent 50%), radial-gradient(ellipse at bottom left, rgba(248, 200, 220, 0.5) 0%, transparent 50%), radial-gradient(ellipse at bottom right, rgba(138, 180, 248, 0.5) 0%, transparent 50%), /* 基础半透明背景 */ rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(18px) saturate(1.5);
    -webkit-backdrop-filter: blur(18px) saturate(1.5);
    backdrop-filter: blur(20px);
    padding: 20px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.login-container {
  .el-form-item {
  margin-bottom: 40px;
}
  box-sizing: border-box;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 22px;
  margin: 0 auto;
  width: 460px;
  padding: 32px 28px 24px 28px;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255,255,255,0.6);
  text-align: left;
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);
}

/* 半透明输入框，使整体更贴近玻璃拟态 */
::v-deep .el-input__inner {
  background-color: rgba(255,255,255,0.6) !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
  border-radius: 12px !important;
  height: 40px;
}
::v-deep .el-input__inner:focus {
  box-shadow: 0 0 0 3px rgba(0,122,255,0.12);
  border-color: #007aff !important;
}

.title {
  margin: 0 auto 14px auto;
  text-align: center;
  color: #111827;
  font-size: 22px;
  font-weight: 700;
}

.segmented {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  background: #bfc0c2;
  border-radius: 14px;
  padding: 4px;
  margin: 10px 0 40px 0;
}
.segmented-track {
  position: absolute;
  inset: 4px;
  border-radius: 12px;
  pointer-events: none;
}
.segmented-thumb {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(50%);
  height: 100%;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04) inset;
  transition: transform .22s ease;
}
.segmented button {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  background: transparent;
  color: #fff;
  padding: 8px 0;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  z-index: 1;
}
.segmented button.active {
  color: #111827;
}

.remember {
  margin: 8px 0 16px 0;
  color: #6b7280;
}

.ios-primary-btn {
  background-color: #007aff !important;
  border-color: #007aff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue